export enum RequestForQuoteStatusEnum {
	Pending = 0,
	SentToSupplier = 10,
	ResponseReceived = 20,
	Won = 30,
	Lost = 40,
}